module.exports = __webpack_public_path__ + "img/content_right1.8642b6ce.png";